// LiveStreamGift.js
import { connect } from 'react-redux';
import Gift from '../component/Gift.jsx';
import notifySendGift from '../action/notifySendGift.js';
import sendLiveStreamGift from '../action/sendLiveStreamGift.js';
import pushToastr from '../action/pushToastr.js';
import toggleModal from '../action/toggleModal.js';
import addvalue from '../action/addvalue.js';
import login from '../action/login.js';
import getGiftData from '../selector/getGiftData.js';
import getOperationData from '../selector/getOperationData.js';
import getHasEnoughBalanceForGift from '../selector/getHasEnoughBalanceForGift.js';
import getMeData from '../selector/getMeData.js';
import { GiftUiType } from '../resource/giftConstants.js';

const getGiftI18nKey = id => `giftname_${id.replace(/-/g, '_')}`;

/**
 * mapStateToProps
 * @param {Object} state - the root state from redux store
 * @param {string} { id } - gift id
 * @return {Object} the object will be the props in the connected component
 */
function mapStateToProps(state, { id, isActive }) {
  const uiType = getGiftData(state, id, 'uiType');
  const isAnimationGift = uiType === GiftUiType.APNG;
  const isPagGift = uiType === GiftUiType.PAG;
  const pagImage = isPagGift ? getGiftData(state, id, 'pagImage') : '';

  const giftSendingStatus = getOperationData(
    state,
    ['liveStream', 'gift'],
    'giftSendingStatus'
  );

  return {
    i18nKey: getGiftI18nKey(id),
    image: getGiftData(state, id, 'image'),
    pagImage,
    price: getGiftData(state, id, 'price'),
    isSwiping: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isGiftPanelSwiping'
    ),
    isAnimationGift,
    isPagGift,
    isActive,
    isSendingGift: 'sending' === giftSendingStatus,
    giftSendingStatus,
    hasEnoughBalance: getHasEnoughBalanceForGift(state, id),
    hasPurchased: getMeData(state, 'hasPurchased'),
    isLoggedIn: !!getMeData(state, 'token'),
  };
}

function mapDispatchToProps(dispatch, { streamId }) {
  return {
    sendGift: ({ giftId }) =>
      dispatch(sendLiveStreamGift({ giftId, streamId })),
    notifySendGift: ({ giftId }) =>
      dispatch(notifySendGift({ streamId, giftId })),
    pushToastr: data => dispatch(pushToastr(data)),
    addvalue: payload => dispatch(addvalue(payload)),
    login: () => dispatch(login({ shouldChooseEntryOption: false })),
    openAnimationFailedModal: ({ giftId, isAnimationGift, isPagGift }) =>
      dispatch(
        toggleModal({
          modalId: 'GiftAnimationFailedConfirmModal',
          payload: {
            animationFailedGiftId: giftId,
            isAnimationGift,
            isPagGift,
            streamId,
          },
          isOpen: true,
        })
      ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Gift);
